import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GridApi } from "ag-grid-community";

import { IstSummaryService } from "src/app/services/ist/ist-summary.service";
import { Subject } from "rxjs";
import { MessageBoxComponent } from "src/app/common/message-box/message-box.component";
import { DeleteBoxComponent } from "src/app/common/delete-box/delete-box.component";
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { EapAmendmentsViewModalComponent } from './eap-amendments-view-modal/eap-amendments-view-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: "app-eap-amendments",
  templateUrl: "./eap-amendments.component.html",
  styleUrls: ["./eap-amendments.component.scss"]
})
export class EapAmendmentsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  Statuslist: any = [];
  amendmentsSearchform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.permission = "";
    if (this.commonService.getPagePermission("EAP08") != null && this.commonService.getPagePermission("EAP08") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP08").toLowerCase();
    }
    this.userType = this.userService.getUserType();
    if (this.userType == "E") {
      this.Statuslist = [
        { "value": "Submitted", "label": "Submitted" },
        { "value": "Draft", "label": "Draft" }
      ];
    }
    else {
      this.Statuslist = [
        { "value": "Submitted", "label": "Submitted" }
      ];
    }

    this.amendmentsSearchform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      Status: new UntypedFormControl(null),
    });

      this.datashareService.ApplicationID.subscribe(x => {
        this.ApplicationID = x;
      });

    this.columnDefs = [
      {
        "headerName": "Type",
        "field": "Type",
        "sort": "asc"
      },
      {
        "headerName": "Title",
        "field": "Title"
      },
      {
        "headerName": "Submitted Date",
        "field": "SubmittedDateStr"
      }
    ];
    this.tempoperations = [

    ];

   if (this.permission == "new") {
      this.tempoperations.push({
        "name": "Add",
        "id": "add"
      });
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
     this.tempoperations.push({
       "name": "Delete",
       "id": "delete"
     });
   }
    if (this.permission == "edit") {
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Type",
          "field": "type",
          "type": "text"
        },
        {
          "label": "Title",
          "field": "Title",
          "type": "text"
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown"
        }
      ]
    };

    this.operations = this.tempoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    this.setSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()
      ? this.gridApi.getSelectedRows()[0]
      : null;
  }

  onRowDoubleClicked(event) {
    const modelRef= this.modalService.open(EapAmendmentsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: "modal-vlg modal-full-height modal-right",
      animation: true
    });
    modelRef.componentInstance.Content= {
      heading: "View",
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    let modalRef = this.modalService.open(
      EapAmendmentsViewModalComponent,
      {
        backdrop: false,
        keyboard: false,
        windowClass: "modal-vlg modal-full-height modal-right",
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: "Add",
        content: { id: "", ApplicationID: this.ApplicationID }

      }
      modalRef.result.then(result=>{
        this['self'].setSummary();
      })
    }

  edit() {
    let hedingText = "Edit";
    if (this['self'].selectedRow["SubmittedDateStr"] != undefined && this['self'].selectedRow["SubmittedDateStr"] != "" && this['self'].selectedRow["SubmittedDateStr"] != null) {
      hedingText = "View";
    }
      let modalRef = this.modalService.open(EapAmendmentsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass:'modal-vlg modal-full-height modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: hedingText,
        content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }

      }
      modalRef.result.then(result=>{
        this['self'].setSummary();
      })
    }

  delete(summaryService, toastrService) {
    if (this['self'].userType == "E") {
      if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
        let id = this['self'].selectedRow['ID'];
        const modalRef = this['self'].modalService.show(DeleteBoxComponent);
         modalRef.result.then(result => {
          summaryService.DeleteRecord('api/EAPAmendments/Delete?RecordID=' + id).subscribe(summary => {
             ;
            if (summary["Status"] == 0) {
              toastrService.success("Selected Record(s) has been Deleted");
              this['self'].setSummary();
            }
            else {
              toastrService.error("Selected Record(s) has been Deleted");
            }
          });
        })

      }
      else {
        this.commonService.ValidationBanner("Record Can't be Deleted.");
        //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be Deleted." } } });
      }
    }
    else {
      this.commonService.ValidationBanner("Record Can't be Deleted.");
      //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be Deleted." } } });
    }


    //let id = this['self'].selectedRow['ID'];
    //this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    //this["self"].modalRef.content.action.subscribe(result => {
    //  service.DeleteRecord('api/ISTAmendments/Delete?RecordID=' + id).subscribe(summary => {
    //    debugger;
    //    if (summary["Status"] == 0) {
    //      this.toastrService.success("Selected Record(s) has been Deleted");
    //      this['self'].setSummary();
    //    }
    //    else {
    //      this.toastrService.error("Selected Record(s) has been Deleted");

    //    }
    //  });
    //})
  }

  setSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/EAPAmendments/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = summary
    });
  }
  getSearchSummary(searchObject) {
     ;
    this.summaryService.fetchSearchData("api/EAPAmendments/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  SearchClear() {
    this.amendmentsSearchform.reset();

    //  this.setSummary();
  }
  AdvanceSearch() {
    var formData = this.amendmentsSearchform.value;
     ;
    formData["ApplicationID"] = this.ApplicationID;
    this.getSearchSummary(formData);
  }
  onAdvanceSearchOperation(searchFiletrs) {

  }
}
